import ConsoleLogger, { Level } from './consoleLogger'

// 環境によりログレベルを設定
let logLevel
if (process.env.NODE_ENV === 'development') {
  logLevel = Level.TRACE
} else {
  logLevel = Level.INFO
}

// ログを初期化
const log: ConsoleLogger = new ConsoleLogger(logLevel)

/**
 * エラーログを出力
 * @param msg メッセージ
 */
export function error(msg: string): void {
  log.error(msg)
}

/**
 * 警告ログを出力
 * @param msg メッセージ
 */
export function warn(msg: string): void {
  log.warn(msg)
}

/**
 * 情報ログを出力
 * @param msg メッセージ
 */
export function info(msg: string): void {
  log.info(msg)
}

/**
 * デバッグログを出力
 * @param msg メッセージ
 */
export function debug(msg: string): void {
  log.debug(msg)
}

/**
 * トレースログを出力
 * @param msg メッセージ
 */
export function trace(msg: string): void {
  log.trace(msg)
}
